export default __webpack_public_path__ + "static/AvenirLTStd-Roman-758726eccd15fcce459c75e9dd21aa95.woff";